import { render, staticRenderFns } from "./ExpiryManagement.vue?vue&type=template&id=57b0b14c&scoped=true"
import script from "./ExpiryManagement.vue?vue&type=script&lang=js"
export * from "./ExpiryManagement.vue?vue&type=script&lang=js"
import style0 from "./ExpiryManagement.vue?vue&type=style&index=0&id=57b0b14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b0b14c",
  null
  
)

export default component.exports